import { render, staticRenderFns } from "./FileTranscribeText.vue?vue&type=template&id=13e8fa59&"
import script from "./FileTranscribeText.vue?vue&type=script&lang=js&"
export * from "./FileTranscribeText.vue?vue&type=script&lang=js&"
import style0 from "./FileTranscribeText.vue?vue&type=style&index=0&id=13e8fa59&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports